module.exports = __webpack_public_path__ + "static/WhenThePastWasAround1-d559311ed0dc028385c14314fc5b0fbc.webp";